import * as React from 'react'
import { cn } from '@/lib/utils'

export interface LogoProps {
  width?: number
  height?: number
  variant?: 'full' | 'icon'
  className?: string
}

const Logo: React.FC<LogoProps> = ({ width = 377, height = 140, variant = 'full', className }) => {
  if (variant === 'icon') {
    const iconSize = Math.min(width, height)
    return (
      <svg width={iconSize} height={iconSize} viewBox="0 0 105 105" xmlns="http://www.w3.org/2000/svg" className={cn(className)}>
        <rect x="0" y="0" width="48" height="48" fill="var(--color-lime)" />
        <rect x="57" y="0" width="48" height="48" fill="var(--color-lime)" />
        <rect x="0" y="57" width="48" height="48" fill="var(--color-lime)" />
        <rect x="57" y="57" width="48" height="48" fill="var(--color-lime)" />
      </svg>
    )
  }

  return (
    <svg width={width} height={height} viewBox="0 0 377 140" xmlns="http://www.w3.org/2000/svg" className={cn(className)}>
      <g transform="translate(20, 17)">
        <rect x="0" y="0" width="48" height="48" fill="var(--color-lime)" />
        <rect x="57" y="0" width="48" height="48" fill="var(--color-lime)" />
        <rect x="0" y="57" width="48" height="48" fill="var(--color-lime)" />
        <rect x="57" y="57" width="48" height="48" fill="var(--color-lime)" />
      </g>
      <g transform="translate(148, 17)">
        <rect x="0" y="0" width="35" height="105" fill="var(--color-cyan)" />
        <rect x="45" y="0" width="35" height="105" fill="var(--color-cyan)" />
      </g>
      <g transform="translate(250, 122)">
        <polygon points="0,0 55,-105 110,0" fill="var(--color-pink)" />
      </g>
    </svg>
  )
}

export { Logo }
